// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"511":"86bf1c90","560":"cdca995e","805":"e36b1ee5","830":"e36b1ee5","842":"e36b1ee5","847":"130db6d0"}[chunkId] + ".chunk.css";
};